<template>
  <div
      @mouseenter="onSidebarMouseEnter"
      @mouseleave="onSidebarMouseLeave"
      class="sidebar"
      :class="{ 'sidebar--mini': !is_pin_active, 'sidebar--hovered': is_hover && !is_pin_active }"
  >
    <div class="sidebar__top">
      <router-link :to="{ name: user.groups[0].index_page }" class="sidebar__logo">
        <img src="@/assets/img/logo-mini.svg" alt="">
        <img v-show="is_pin_active || is_hover" src="@/assets/img/part-of-logo-icon.svg" alt="">
      </router-link>
      <label v-if="is_pin_active || is_hover" class="sidebar__pin">
        <input @change="onPinChange" v-model="is_pin_active" type="checkbox">
        <span></span>
      </label>
    </div>
    <div v-if="is_pin_active || is_hover" class="sidebar__middle">
      <app-sidebar-menu :groups="user.groups" />
    </div>
    <div class="sidebar__bottom">
      <router-link :to="{ name: 'me' }" class="sidebar__user">
        <div class="sidebar__ava-wrapper">
          <div class="sidebar__ava">
            <img :src="userAvatar" alt="Avatar">
          </div>
          <img v-if="user.is_2fa_enabled" class="sidebar__2fa" src="@/assets/img/2fa-enabled-icon.svg" alt="">
          <img v-else class="sidebar__2fa" src="@/assets/img/2fa-not-enabled-icon.svg" alt="">
        </div>
        <div v-if="user && (is_pin_active || is_hover)" class="sidebar__username">{{ user.first_name }} {{ user.last_name }}</div>
      </router-link>
      <button @click="onLogout" class="sidebar__logout">
        <img src="@/assets/img/logout.svg" alt="">
      </button>
    </div>
  </div>
</template>

<script>
import AppSidebarMenu from '@/components/AppSidebarMenu'
import { clearAuthTokens, isLoggedIn } from 'axios-jwt'
import { getMe } from '@/http'

export default {
  name: 'AppSidebar',
  components: { AppSidebarMenu },
  props: {
    user: Object,
  },
  data() {
    return {
      is_pin_active: true,
      is_hover: false
    }
  },
  computed: {
    userAvatar() {
      if (this.user && this.user.crop.crop_url) return this.user.crop.crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    isPinActive() {
      return JSON.parse(localStorage.getItem('is_pin_active'))
    }
  },
  mounted() {
    if (localStorage.getItem('is_pin_active')) {
      this.is_pin_active = this.isPinActive
      this.$store.commit('changeSidebarSize', this.isPinActive)
      localStorage.setItem('is_pin_active', this.isPinActive)
    }
  },
  methods: {
    onSidebarMouseEnter() {
      this.is_hover = true
    },
    onSidebarMouseLeave() {
      this.is_hover = false
    },
    onPinChange() {
      this.$store.commit('changeSidebarSize', this.is_pin_active)
      localStorage.setItem('is_pin_active', this.is_pin_active)
    },
    onLogout() {
      clearAuthTokens()
      localStorage.clear()
      this.$router.push({ name: 'login' })
    },
  },
}
</script>

<style lang="sass" scoped>
.sidebar
  position: fixed
  z-index: 100
  width: 220px
  height: 100vh
  overflow: hidden
  background-color: #404040
  transition: width 0.3s

  +max-w($desktop_sm)
    width: 200px

.sidebar--mini
  width: 60px
  transition: width 0.3s

.sidebar--hovered
  width: 220px

.sidebar__top
  display: flex
  align-items: center
  justify-content: space-between
  height: 60px
  padding: 0 12px
  border-bottom: 1px solid #525252

.sidebar__logo
  position: relative
  display: flex
  align-items: center
  gap: 9px
  line-height: 0
  transition: opacity 0.3s

  &:hover
    opacity: 0.8

  img:first-child
    flex-shrink: 0
    min-width: 36px

.sidebar__bottom
  position: absolute
  bottom: 0
  left: 0
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%
  height: 60px
  padding: 0 11px 0 16px
  border-top: 1px solid #525252

.sidebar__user
  display: flex
  align-items: center
  gap: 5px 12px

.sidebar__ava-wrapper
  position: relative

.sidebar__ava
  flex-shrink: 0
  width: 30px
  height: 30px
  border-radius: 50%
  overflow: hidden

  > img
    width: 100%
    height: 100%
    object-fit: cover

.sidebar__2fa
  position: absolute
  bottom: 0
  right: -8px
  width: 15px

.sidebar__username
  color: #fff
  transition: opacity 0.3s

.sidebar__logout
  padding: 5px
  line-height: 0
  transition: opacity 0.3s

  &:hover
    opacity: 0.8

.sidebar__middle
  height: calc(100% - 120px)
  overflow: hidden auto
  scrollbar-color: $color-theme #404040
  scrollbar-width: thin

  &::-webkit-scrollbar
    width: 4px
    transition: width 0.3s

  &::-webkit-scrollbar-track
    background-color: #404040

  &::-webkit-scrollbar-thumb
    background-color: $color-theme

.sidebar__pin
  line-height: 0

  input
    +visually-hidden

    &:checked ~ span
      border: none
      background-color: $color-theme

      &:after
        content: ''
        position: absolute
        top: 6px
        left: 6px
        display: inline-block
        width: 4px
        height: 4px
        border-radius: 50%
        background-color: #fff

  span
    position: relative
    display: inline-block
    width: 16px
    height: 16px
    border-radius: 50%
    border: 1px solid #757575
    cursor: pointer

</style>
